"use strict";
import { useMutation } from "@connectrpc/connect-query";
import { createConnectTransportWithDefaults } from "data/rest/base";
import { proxy } from "data/rest/conversionTracking/api/api-ConversionProxyService_connectquery";
import { getConversionProxyApiBaseUrl } from "data/rest/conversionTracking/utils";
const conversionProxyTransport = createConnectTransportWithDefaults({
  baseUrl: getConversionProxyApiBaseUrl()
});
export function useConversionProxy() {
  return useMutation(proxy, { transport: conversionProxyTransport });
}
